import type { ChangeEvent, FC, FocusEvent, ReactElement } from 'react'
import { useState } from 'react'

import type { WhiteLabel } from '@skytech/types'

import { ErrorMessage } from '../ErrorMessage'
import { Label } from '../Label'

import './styles.scss'

export const Toggle: FC<{
  id: string
  checked: boolean
  error?: string | ReactElement
  touched?: boolean
  label?: string | ReactElement
  capitalizeLabel?: boolean
  marginBottom?: number
  marginTop?: number
  marginLeft?: number
  className?: string
  whiteLabel?: WhiteLabel
  name?: string
  isDisabled?: boolean
  onChange: (e: ChangeEvent<HTMLInputElement>) => void
  onBlur?: (e: FocusEvent<unknown, Element>) => void
  onFieldChange?: () => void
}> = ({
  id,
  label,
  checked,
  capitalizeLabel,
  marginBottom,
  marginTop,
  name,
  error,
  touched,
  className = '',
  whiteLabel: _whiteLabel,
  isDisabled,
  onBlur,
  onChange,
  onFieldChange,
}) => {
  const [focused, setFocused] = useState(false)
  const onFocus = () => {
    setFocused(true)
  }
  const onDefaultBlur = () => setFocused(false)
  const onCustomBlur = (e: FocusEvent<unknown, Element>) => {
    onBlur?.(e)
    setFocused(false)
  }

  // todo: replace with the org from url when ready
  const storedWhiteLabel = localStorage.getItem('org') as WhiteLabel
  const whiteLabel = _whiteLabel || storedWhiteLabel || 'control'

  const classNameContainer = `ui-toggle ${className} ${focused ? 'is-focused' : 'is-blurred'} ${
    checked ? 'is-checked' : ''
  } ${isDisabled ? 'is-disabled' : ''} ${whiteLabel}`

  return (
    <label
      htmlFor={id}
      className={classNameContainer}
      style={{
        marginBottom: marginBottom || 0,
        marginTop: typeof marginTop === 'number' ? marginTop : '0',
      }}
    >
      <input
        id={id}
        name={name}
        type="checkbox"
        checked={checked}
        disabled={isDisabled}
        onChange={e => {
          onChange(e)
          if (onFieldChange) onFieldChange()
        }}
        onFocus={onFocus}
        // Crucial for setting the "touched" fields
        onBlur={onCustomBlur || onDefaultBlur}
      />

      {label && (
        <Label capitalizeLabel={capitalizeLabel} htmlFor={id}>
          {label}
        </Label>
      )}

      {error && touched && <ErrorMessage>{error}</ErrorMessage>}
    </label>
  )
}
